import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { AuthService } from '../../../core/auth/auth.service';
import { AlertService } from '../../../shared/services/alert.service';

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule],
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent {
  registerForm: FormGroup;
  showPassword = false;
  showConfirmPassword = false;
  private fb = inject(FormBuilder);
  private auth = inject(AuthService);
  private router = inject(Router);
  private alertService = inject(AlertService);

  constructor() {
    this.registerForm = this.fb.group({
      name: ['', Validators.required],
      phoneNumber: ['', [
        Validators.required,
        Validators.pattern(/^(\+994 \((50|51|10|70|77|55|99)\) \d{3}-\d{2}-\d{2}|\+994 (50|51|10|70|77|55) \d{3} \d{2} \d{2})$/)
      ]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', Validators.required]
    }, { validators: this.passwordMatchValidator });
  }


  private passwordMatchValidator(control: AbstractControl): ValidationErrors | null {
    const password = control.get('password');
    const confirmPassword = control.get('confirmPassword');

    if (password && confirmPassword && password.value !== confirmPassword.value) {
      return { mismatch: true };
    }
    return null;
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPasswordVisibility(): void {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  onPhoneInput(event: any): void {
    const input = event.target;
    let value = input.value;
    const selectionStart = input.selectionStart;
    const oldLength = value.length;

    // Yalnız rəqəmləri saxlayırıq
    let digits = value.replace(/\D/g, '');

    // Əgər +994 ilə başlayırsa, onu çıxarırıq (formatlamada yenidən əlavə olunacaq)
    if (digits.startsWith('994')) {
      digits = digits.substring(3);
    }

    // Maksimum 9 rəqəm (operator + nömrə)
    digits = digits.substring(0, 9);

    let formattedValue = '+994 ';
    if (digits.length > 0) {
      formattedValue += '(' + digits.substring(0, 2);
      if (digits.length > 2) {
        formattedValue += ') ' + digits.substring(2, 5);
        if (digits.length > 5) {
          formattedValue += '-' + digits.substring(5, 7);
          if (digits.length > 7) {
            formattedValue += '-' + digits.substring(7, 9);
          }
        }
      }
    }

    this.registerForm.get('phoneNumber')?.setValue(formattedValue, { emitEvent: false });

    // Kursorun mövqeyini hesablamaq və bərpa etmək
    setTimeout(() => {
      const newLength = formattedValue.length;
      let newSelection = selectionStart + (newLength - oldLength);

      // Kursorun yanlış yerdə qalmaması üçün tənzimləmə
      input.setSelectionRange(newSelection, newSelection);
    }, 0);
  }

  onSubmit(): void {
    if (this.registerForm.valid) {
      const formValue = this.registerForm.value;

      // Format phone: +994XXXXXXXXX
      const phone = formValue.phoneNumber.replace(/\s+/g, '').replace(/[()\-]/g, '');

      const registerData = {
        name: formValue.name,
        phone: phone,
        password: formValue.password,
        confirmPassword: formValue.confirmPassword
      };

      // Qeydiyyatdan keçmək üçün əvvəlcə OTP göndərilir
      this.auth.sendOtp(phone).subscribe({
        next: () => {
          this.auth.setPendingRegisterData(registerData);
          this.alertService.success('OTP kod telefonunuza göndərildi.');
          this.router.navigate(['/otp-verification'], { queryParams: { phone: phone, type: 'register' } });
        },
        error: (err) => {
          const errorObj = err.error?.error || err.error;
          const errorCode = errorObj?.code || 'UNKNOWN_ERROR';
          const errorDetails = errorObj?.details;
          this.alertService.errorByCode(errorCode, errorDetails);
        }
      });
    } else {
      this.registerForm.markAllAsTouched();
    }
  }
}
